<template>
  <div :data-id="pageId">
    <slot></slot>
  </div>
</template>

<script src="./dialog-popup-page.js"></script>
